import styles from "./styles.module.sass";
import TextInput from "../../components/Form/TextInput";
import { Formik } from "formik";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import Row from "react-bootstrap/Row";
import { agentLogin } from "../../state/actions/accountActions";
import cn from "classnames";
import Col from "react-bootstrap/Col";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet-async";
import faviconAdmin from "../../favicon_green.ico";
import { loginValidationSchema } from "../../validation/loginValidation";

const AgentLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const initialValues = { first_name: "", last_name: "", password: "" };

  const handleSubmit = (values) => {
    dispatch(agentLogin(values)).then((res) => {
      if (res?.status === 200) {
        navigate("/home");
      }
    });
  };
  return (
    <div className={styles.container}>
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="icon" href={faviconAdmin} />
        <title>AgentPortal - Login</title>
      </Helmet>
      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={loginValidationSchema}
      >
        {({ handleSubmit, handleChange, values, touched, errors }) => (
          <Form className={styles.subcontainer}>
            <Row className={cn("mb-3")}>
              <Col xs={12}>
                <TextInput
                  idName={"first_name"}
                  values={values}
                  formName="first_name"
                  handleChange={handleChange}
                  placeholder="Agentsko Ime"
                  label="Agentsko Ime"
                  errors={errors}
                  touched={touched}
                  type="first_name"
                />
              </Col>
            </Row>
            <Row className={cn("mb-3")}>
              <Col xs={12}>
                <TextInput
                  idName={"last_name"}
                  values={values}
                  formName="last_name"
                  handleChange={handleChange}
                  placeholder="Agentsko Prezime"
                  label="Agentsko Prezime"
                  errors={errors}
                  touched={touched}
                  type="last_name"
                />
              </Col>
            </Row>
            <Row className={cn("mb-3")}>
              <Col xs={12}>
                <TextInput
                  idName={"password"}
                  values={values}
                  type="password"
                  formName="password"
                  handleChange={handleChange}
                  placeholder="Unesite Šifru"
                  label="Agentska Šifra"
                  errors={errors}
                  touched={touched}
                />
              </Col>
            </Row>
            <button
              type="button"
              className={cn(styles.button, "mt-3")}
              onClick={handleSubmit}
            >
              Prijava
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AgentLogin;
